import LocationPin from '../../src/legacy/LocationPin.tsx';
export default LocationPin;
